<template>
  <v-container class="top-spacer" style="padding:0">
    <div class="component-title">Tiro Certeiro</div>
    <v-row>
      <v-col cols="12" v-if="!isPremium">
        <PremiumContent></PremiumContent>
      </v-col>
      <v-col cols="12" v-else>
        <v-row>
          <v-col class="tiro-certeiro-card">
            <div class="card-label">Dados gerais</div>
            <TiroCerteiroCard
              :tiroCerteiro="current"
              :ranking="ranking.slice(0,5)"
            ></TiroCerteiroCard>
          </v-col>
          <v-col class="tiro-certeiro-table">
            <div class="card-label">Ranking Top 10</div>
            <TiroCerteiroTable :tableData="tableData"></TiroCerteiroTable>
          </v-col>
        </v-row>
        <!-- Prognósticos -->
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>
.tiro-certeiro-card {
  flex: 0 0 30%;
  max-width: 30%;
}
.tiro-certeiro-table {
  flex: 0 0 70%;
  max-width: 70%;
}
@media only screen and (max-width: 1112px) {
  .tiro-certeiro-card,
  .tiro-certeiro-table {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
@media only screen and (max-width: 768px) {
  .tiro-certeiro-card,
  .tiro-certeiro-table {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
</style>

<script>
import TiroCerteiroCard from "@/components/TiroCerteiroCard.vue";
import TiroCerteiroTable from "@/components/TiroCerteiroTable.vue";
import PremiumContent from "../components/PremiumContent.vue";

import ApiService from "@/services/api.service";

export default {
  name: "TiroCerteiro",
  components: {
    TiroCerteiroCard,
    TiroCerteiroTable,
    PremiumContent
  },
  data: () => ({
    tipoPrognostico: ["Tipo", "Simples", "Múltiplo"],
    estadoPrognostico: [""],
    current: {},
    ranking: [],
    tableData: []
  }),
  methods: {
    getRanking() {
      ApiService.getGraphQLCurrentTiroCerteiroRanking().then(
        response => {
          const data = response.data.data;
          this.current = data.getCurrentTiroCerteiro;
          this.tableData = data.getCurrentTiroCerteiroRanking;
          this.ranking = this.$lodash.cloneDeep(this.tableData);
          const empty = 5 - this.ranking.length;
          for (let i = 0; i < empty; i++) {
            this.ranking.push({});
          }
        },
        error => {
          console.log(
            (error.response && error.response.data) ||
              error.message ||
              error.toString()
          );
        }
      );
    }
  },
  computed: {
    isPremium() {
      return this.$store.state.premium;
    }
  },
  created() {
    this.getRanking();
  }
};
</script>
